export const CHART_COLORS = {
    red: "#ff6384",
    yellow: "#FFC107",
    green: "#004D40",
    pink: "#D81B60",
    white: "#FFFFFF",
    black: "#000000",
};
export const TENNISCORES = "tenniscores";
export const PTI_V2 = "pti_v2"; // This is os_sets_mod in backend
// To configure a new rater, simple add the entry in this RATERS_AVAILABLE list.
// This assumes the sim backend is configured with the rating algorithm.
// Example:
// const YOUR_NEW_RATING_ALGO = "a_new_rating_algo";
// export const RATERS_AVAILABLE = [PTI_V2, YOUR_NEW_RATING_ALGO];
// Also, add a color to RATERS_COLOR map
export const LIVE_RATER = PTI_V2;
export const RATERS: string [] = [];
export const RATERS_AVAILABLE = [PTI_V2];
export const RATERS_OVERRIDE_PREFIXES = RATERS_AVAILABLE.map((rater) => `${rater}_`);
export const RATERS_COLORS: { [key: string]: string } = {
    [PTI_V2]: CHART_COLORS.pink,
};
export const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
